import React, { useEffect, useState } from 'react';
import "../CSS/style.css";
import { FaHome,FaListAlt,FaUserCheck} from "react-icons/fa";
import { GiHamburgerMenu} from "react-icons/gi";
import { BsFillCollectionFill,BsGraphUp} from "react-icons/bs";
import imagen from "../Img/NewLogo.jpg";
import userm from '../Img/ic-um.png'
import userw from '../Img/ic-uw.png'
import { Link,Outlet, useNavigate } from 'react-router-dom';
import { TbArrowsLeftRight } from "react-icons/tb";
import ModalChangePassword from './ModalChangePassword';
import { HiOutlineLockClosed,HiOutlineLogout } from "react-icons/hi";
import { FaCoins } from "react-icons/fa";
import { getApi } from '../Conexiones/Models';
import { errorMessage, warningModal } from '../Utils/AlertMessage';
//backgroundImage:'url(/img/snwflks-5.gif)', backgroundSize:'100% '

function Home() {
    const usuario = JSON.parse(sessionStorage.getItem('user')) 
    const nombre = usuario[0].nombre
    const sexo = usuario[0].sexo
    const idUser = usuario[0].idUsuario
    const [catalogo,setCatalogo]=useState([])
   
    const [show, setShow] = useState(false);
    const [selected, setSelected] = useState(verifyPath());
    const navigate = useNavigate()
    const logout = () => {
        warningModal('¿QUIERE CERRAR SESIÓN?')
        .then(async (result) => {
            if (result.isConfirmed) {
                sessionStorage.removeItem('user')
                navigate('/')
            }
        })
    }
    
    function verifyPath() {
        const path = window.location.pathname;
        const arrPath = path.split('/');
        const name = arrPath[2];
        var sel = 15;
        if(name === undefined){
            sel = 15;
        }else{
            if(name === "Catalogos"){
                sel = 16;
            }else{
                if(name === "Proyectos"){
                    sel = 17;
                }else{
                    if(name === "Prestamos"){
                        sel = 18;
                    }else{
                        if(name === "Oficina"){
                            sel = 19;
                        }else{
                            if(name === "Ingresos"){
                                sel = 20;
                            }else{
                                if(name === "Contabilidad"){
                                    sel = 21;
                                }else{
                                    sel = 15;
                                }
                            }
                        }
                    }
                }
            }
        }
        return sel;
    }
    
    useEffect (()=>{
        const getCatalogo = async () =>{
            const endpoint = 'getCatalogosMenu/'+idUser;
            const res = await getApi(endpoint);
            if(res.status === 1){
                if(res.data.length !== undefined){
                    setCatalogo(res.data);
                }else{
                    errorMessage(res.data.message);
                }
            }else if(res.status === 210){
                navigate('/');
            }else{
                errorMessage(res.message);
            }
        }
        setSelected(verifyPath());
        getCatalogo();
    },[idUser, navigate])

    const icons = [{id:16,icono:BsFillCollectionFill},{id:17,icono:FaListAlt},{id:18,icono:TbArrowsLeftRight},{id:19,icono:FaUserCheck},{id:20,icono:BsGraphUp},{id:21,icono:FaCoins}]

    /*const [aviso,setAviso] = useState()
    //const [newPass, setNewPass] = useState('')
    //const [confirmPass, setConfirmPass] = useState('')
    useEffect( ()=>{
        const verificarClave = async () =>{
            try {
                const res = await axios.get(URI + 'access/'+idUser,{
                    headers: {
                        'Authorization': `Bearer ${getToken()}`
                    },
                })
                if(res.status === 210){
                    navigate('/')
                }else{
                    setAviso(res.data.message)
                }
            } catch (error) {
                console.log(error)
            }
        }
        verificarClave()
    }, [idUser, navigate])
    if(aviso === "CAMBIAR CONTRASEÑA"){
        Swal.fire({
            icon: 'warning',
            title: `<label class='text-uppercase'>HOLA ${nombre}</label> `,
            text: 'ACTUALICE SU CONTRASEÑA',
            showConfirmButton: true,
            confirmButtonText: 'ACEPTAR',
            allowOutsideClick: false,
            allowEscapeKey: false,
        })
    }*/
    const [showP, setShowP] = useState(false);
    const handleClose = () => setShowP(false);
    const handleShow = () => setShowP(true);

    return (
        <div className="contenedor">
            <ModalChangePassword show={showP} handleClose={handleClose} />
            <div  className={`navegador ${show ? null :'activo' }`}>
                <ul>
                    <li>
                        <Link to='' >
                            <span className="icono">
                                <img src={imagen} style={{width:"40px"}} alt=""></img>
                            </span>
                            <span className="titulo">ROSMO</span>
                        </Link>
                    </li>
                    <li className={selected===15?'active':null} key={15} onClick={()=>setSelected(15)}>
                        <Link to="/inicio"  >
                            <span className="icono">
                                <FaHome title="Principal"/>
                            </span>
                            <span className="titulo">Inicio</span>
                        </Link>
                    </li> 
                    {catalogo.map((dato,index)=>{
                        const resultado = icons.filter(num => num.id === dato.idModulo);
                        const Icon = resultado[0].icono;
                        return(
                            <li className={selected===dato.idModulo?'active':null} key={index} onClick={()=>setSelected(dato.idModulo)}>
                                <Link to={dato.enlace}  >
                                    <span className="icono">
                                        <Icon title={dato.nomModulo}/>
                                    </span>
                                    <span className="titulo">{dato.nomModulo}</span>
                                </Link>
                            </li> 
                        )
                    })}
                </ul>
            </div>
            <div className={`principal ${show ? null : 'activo'}`} >
                <div className="barra" style={{position:"fixed",zIndex:"1"}}>
                    <div className="menu"  onClick={() => setShow(!show)}>
                        <GiHamburgerMenu/>
                    </div>
                    <div className="buscar">
                        <label>
                            {/*<input type="text" placeholder="Buscar"/>*/}
                        </label>
                    </div>
                </div>
                <div className='usuario'>
                    <div className="dropdown">
                        <a className="dropdown-toggle perfil " href='menu' data-bs-toggle="dropdown"  aria-expanded="false">                        
                            {/*LABEL */}
                            <label className="usuario-nombre">HOLA, {nombre.toUpperCase()}&nbsp;</label>
                            {sexo === "f" ? (
                                    <img src={userw}  alt="" />
                                ):(
                                    <img src={userm}  alt="" />
                                )
                            }
                        </a>
                        <ul className="dropdown-menu">
                            <label className="nombre-usuario">HOLA, {nombre.toUpperCase()}</label>
                            <li>
                                <button className="dropdown-item" onClick={handleShow} >
                                    <div style={{display:'flex', alignItems:'center', justifyContent:'center'}}>
                                        <div style={{width:'10%',display:'flex', alignItems:'center', justifyContent:'center'}}>
                                            <HiOutlineLockClosed />
                                        </div>
                                        <div style={{width:'90%',display:'flex', alignItems:'center', justifyContent:'left', padding:'0 5px'}}>
                                            Cambiar contraseña
                                        </div>
                                    </div>
                                </button>
                            </li>
                            <li><hr className="dropdown-divider"/></li>
                            <li>
                                <button className="dropdown-item" onClick={() => logout()} >
                                <div style={{display:'flex', alignItems:'center', justifyContent:'center'}}>
                                        <div style={{width:'10%',display:'flex', alignItems:'center', justifyContent:'center'}}>
                                            <HiOutlineLogout/>
                                        </div>
                                        <div style={{width:'90%',display:'flex', alignItems:'center', justifyContent:'left', padding:'0 5px'}}>
                                            Cerrar sesión
                                        </div>
                                    </div>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
                <Outlet/>  
            </div>
        </div>    
    );
}

export default Home;